/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qr_Stop_ScanningInputs */

const vi_qr_stop_scanning = /** @type {(inputs: Qr_Stop_ScanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dừng quét`)
};

/**

* @param {Qr_Stop_ScanningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const qr_stop_scanning = /** @type {((inputs?: Qr_Stop_ScanningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qr_Stop_ScanningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_qr_stop_scanning(inputs)
});